module.exports = __webpack_public_path__ + "img/es-ES.40260d1a.svg";